import { AgGridReact } from "ag-grid-react";
import { ColDef, ICellRendererParams, RowClassParams, RowClickedEvent } from "ag-grid-enterprise";

import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { Group, Paper } from "@mantine/core";
import DeviceIcon from "../../SelectedSpace/DeviceIcon";
import { selectHttpDevicesInRoom, setSelectedDeviceId } from "../../DesignTab/devices/deviceSlice";
import { IDevice } from "@multiconsult-group/multiplacer-core";

const normalizeText = (value?: string | null): string => {
  if (value == null) return "-";
  const trimmed = value.trim();
  return trimmed === "" ? "-" : trimmed;
};

const MultplacerCeilingDevicesTable: React.FC = () => {
  const dispatch = useAppDispatch();

  const devicesInRoom = useAppSelector(selectHttpDevicesInRoom);

  const selectedDeviceId = useAppSelector((state) => state.device.selectedDeviceId);
  const columns: ColDef<IDevice>[] = [
    { field: "_id", hide: true },
    { field: "deviceCategory", hide: true, sort: "desc" },
    {
      field: "compCode",
      headerName: "Artikkelnr",
      width: 150,
      cellRenderer: (params: ICellRendererParams<IDevice>) => {
        const value = normalizeText(params.data?.compCode);
        return (
          <Group gap="xs">
            <DeviceIcon deviceType={params.data?.deviceCategory} />
            <span>{value}</span>
          </Group>
        );
      },
    },
    {
      field: "description",
      headerName: "Beskrivelse",
      flex: 1,
      cellRenderer: (params: ICellRendererParams<IDevice>) => {
        const value = normalizeText(params.data?.description);
        return <span>{value}</span>;
      },
    },
  ];

  const rowClassRules = {
    "ag-row-selected": (params: RowClassParams<IDevice>) => params.data?._id === selectedDeviceId,
  };

  return (
    <Paper p="xs" style={{ height: "100%", backgroundColor: "#ffffff", overflow: "scroll" }}>
      <div className="ag-theme-quartz" style={{ overflow: "auto", width: "100%", height: "100%" }}>
        <AgGridReact
          domLayout="autoHeight"
          onRowClicked={(event: RowClickedEvent<IDevice>) => {
            dispatch(setSelectedDeviceId(event.data?._id as string));
          }}
          getRowId={(p) => p.data._id as string}
          columnDefs={columns}
          rowData={devicesInRoom.filter((device) => device.grid == null)}
          rowClassRules={rowClassRules}
        />
      </div>
    </Paper>
  );
};

export default MultplacerCeilingDevicesTable;
